import Vuex from 'vuex';

const state = {
  show: false,
	full: false,
	cb: null,
};

const getters = {
  show: state => state.show,
	full: state => state.full,
	callback: state => state.cb,
};

const actions = {
  show: ({ state, commit, dispatch }, { show, full, cb }) => {
		if(!show || typeof(full) === 'undefined') {
			full = false;
		}
		if(typeof(cb) !== 'function') {
			cb = null;
		}
		commit('show', { show, full, cb });
  },
	hide: ({ state, commit }) => {
		commit('hide');
	}
};

const mutations = {
	show: (state, { show, full, cb }) => {
		state.show = show;
		state.full = full;
		state.cb = cb;
	},
	hide: (state) => {
		state.show = false;
		state.full = false;
	},
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ../shared/store/modules/overlay.js